import React, { useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const MessageAlert = ({ message, type = 'error', onHide }) => {
    useEffect(() => {
        if (!message) return;
        const timer = setTimeout(() => onHide?.(), 4000); // auto-hide after 4s
        return () => clearTimeout(timer);
    }, [message, onHide]);

    if (!message) return null;

    const isSuccess = type === 'success';

    return (
        <div
            className={`position-fixed top-0 end-0 m-24 px-20 py-12 radius-8 d-flex align-items-center gap-2 shadow ${
                isSuccess
                    ? 'bg-success-100 text-success-600 border border-success-600'
                    : 'bg-danger-100 text-danger-600 border border-danger-600'
            }`}
            style={{ zIndex: 9999 }}
            role="alert"
        >
            <Icon
                icon={isSuccess ? 'mdi:check-circle-outline' : 'mdi:alert-circle-outline'}
                className="text-xl"
            />
            <span className="fw-medium">{message}</span>
            <button
                type="button"
                onClick={onHide}
                className="border-0 bg-transparent ms-2"
                style={{ color: 'inherit' }}
            >
                <Icon icon="mdi:close" />
            </button>
        </div>
    );
};

export default MessageAlert;